export default {
  hasUserLoggedIn: false,
  loggedInUser: null,
  users: []
};
